var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgConditioner = function SvgConditioner(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1149",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M302.67 254.27c2.023 15.818 7.734 30.446 14.636 42.22 18.443 31.398 27.962 12.607 20.347 3.33-8.567-10.466-15.112-21.764-18.8-38.296-1.428-6.184-1.19-20.456-5.592-23.072-12.137-7.136-11.542 8.682-10.59 15.818z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1151",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M58.271 257.84c1.19-7.017 4.403-20.932-6.068-20.456-9.282.238-7.14 11.774-8.687 20.099-6.544 34.609-22.965 41.031-22.846 49.237.12 4.4 3.094 7.136 7.497 6.779 11.78-.595 27.248-38.414 30.104-55.659z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1153",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M266.74 313.86c5.95-12.607-5.592-12.131-12.851-38.533-5.235-18.553-1.428-31.992-5.83-36.036-2.618-2.379-6.902-2.616-9.757-.238-8.687 7.374 1.903 47.691 12.494 65.531 3.926 6.541 6.425 12.131 15.945 9.277z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1155",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M124.79 263.79c4.998-34.371-9.4-26.878-12.018-23.786-4.76 5.709 3.094 26.402-13.089 54.708-2.618 4.4-11.78 13.677-4.522 18.91 14.16 10.109 27.724-36.631 29.628-49.832z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path1157",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M173.69 309.1c1.309 7.136 10.947 7.85 13.565 1.665 1.547-3.806 1.19-63.033.595-67.077-1.428-8.682-11.661-8.206-13.684-2.022z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path1159",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M347.89 136.89c.714-19.505.952-39.723-.833-58.989-2.737-27.473-8.21-26.759-34.864-26.759H36.023c-11.542 0-17.729.476-22.25 8.563-9.044 16.056-4.166 93.004-2.857 114.17 1.547 24.5 15.231 27.235 33.793 27.235h245.47c20.823 0 41.408 3.806 50.808-10.228 7.14-10.585 6.426-39.009 6.902-53.994zM54.7 186.722h247.5c.119-6.303 0-23.429 0-29.733 0-10.347.119-14.391-7.496-14.391l-233.46.357c-7.735.476-6.664 6.065-6.545 13.2 0 6.66-.119 24.025 0 30.566zm212.99-114.65c-4.878 0-8.924 4.044-8.924 8.92 0 4.995 4.045 8.92 8.924 8.92 4.998 0 8.924-3.925 8.924-8.92 0-4.876-3.926-8.92-8.924-8.92m-160.04 4.044h129.58c3.213 0 5.711 2.616 5.711 5.708 0 3.211-2.498 5.828-5.711 5.828H107.65c-3.213 0-5.83-2.617-5.83-5.828 0-3.092 2.617-5.708 5.83-5.708"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConditioner);
export default ForwardRef;